const Callout = {
  parts: [
    'container',
    'containerInner',
    'content',
    'textSection',
    'textContainer',
    'subtitle',
    'title',
    'button',
    'image'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      bg: 'brandColors.primaryBG', // #F7F5F0
    },
    containerInner: {
      maxWidth: '1440px',
      mx: 'auto',
      width: 'full',
      py: {base: 5, md: 30}, // 20px mobile, 120px desktop
      px: {base: 5, md: 20}, // 20px mobile, 80px desktop
      display: 'flex',
      flexDirection: {base: 'column', lg: 'row'},
      position: 'relative',
    },
    content: {
      display: 'flex',
      width: {base: 'full', lg: '50%'},
      p: {base: '40px 20px', md: '48px 72px 48px 48px'},
      flexDirection: {base: 'column', md: 'row'},
      justifyContent: {base: 'center', md: 'flex-end'},
      alignItems: {base: 'center', md: 'flex-end'},
      gap: {base: 7.5, md: 0}, // 30px mobile, 0 desktop
      bg: {base: 'transparent', md: 'brandColors.greyscale90'}, // Mobile uses background image with gradients
      position: 'relative',
      minHeight: {base: 'none', lg: '100%'},
      mx: 'auto',
      // Mobile background with gradients and image
      backgroundImage: {
        base: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 44.28%), linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%)',
        md: 'none',
      },
      zIndex: 1,
    },
    textSection: {
      display: 'flex',
      width: {base: 'full', md: 'auto'},
      flexDirection: 'column',
      justifyContent: {base: 'center', md: 'flex-end'},
      alignItems: {base: 'center', md: 'flex-start'},
      gap: 6, // 24px
      flex: '1 0 0',
      zIndex: 2,
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: {base: 'center', md: 'flex-start'},
      gap: 4, // 16px
      alignSelf: 'stretch',
    },
    subtitle: {
      width: {base: 'full', md: '334px'},
      color: 'brandColors.primaryLinen100', // #C6B5A1 - Primary Linen 100
      fontFamily: 'heading',
      fontSize: '2xs', // 10px
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '120%', // 12px
      letterSpacing: '2px',
      textTransform: 'uppercase',
      textAlign: {base: 'center', md: 'left'},
    },
    title: {
      alignSelf: 'stretch',
      color: {base: 'brandColors.primaryBG', md: 'white'}, // #F7F5F0 mobile, #FFF desktop
      fontFamily: 'heading',
      fontSize: {base: 'xl', md: '28px'}, // 20px mobile, 28px desktop
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '120%', // 24px mobile, 33.6px desktop
      letterSpacing: {base: '0px', md: '-0.28px'}, // 0px mobile, -0.28px desktop
      textAlign: {base: 'center', md: 'left'},
      mb: 0,
    },
    button: {
      display: 'flex',
      height: '54px',
      p: '14px 48px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1.5, // 6px
      flexShrink: 0,
      borderRadius: '4px',
      border: '1px solid',
      borderColor: 'brandColors.primaryLinen100', // #C6B5A1 - Primary Linen 100
      bg: 'transparent',
      color: 'brandColors.primaryLinen100', // #C6B5A1 - Primary Linen 100
      fontFamily: 'heading',
      fontSize: 'sm', // 14px
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '120%', // 16.8px
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      _hover: {
        bg: 'brandColors.primaryLinen100',
        color: 'brandColors.greyscale90',
        transform: 'translateY(-1px)',
      },
      _active: {
        transform: 'translateY(0)',
      },
    },
    image: {
      width: {base: 'calc(100% - 40px)', lg: '50%'},
      height: {base: 'calc(100% - 40px)', lg: 'auto'},
      flex: {base: 'none', lg: '0 0 50%'},
      position: {base: 'absolute', lg: 'static'},
      top: 5,
      left: 5,
      objectFit: 'cover',
      display: 'block', // Hide on mobile since we use background image
      aspectRatio: {base: 'auto', md: '640/350'},
    },
  },
};

export default Callout;
